import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { FiCreditCard } from "react-icons/fi";
import CrudEditPage from "../../../components/crud/CrudEditPage";
import FormGrid, { FormField } from "../../../components/crud/FormGrid";
import { accounts } from "../../utils/accountConstants";

const UpdateAccountBalance = () => {
	const [data, setData] = useState({ account: "", value: "" });
	const [loading, setLoading] = useState(false);

	const navigate = useNavigate();
	const location = useLocation();
	const id = location.pathname.split("/")[2];

	useEffect(() => {
		const fetchAllData = async () => {
			try {
				const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/money/${id}`);
				setData(res.data);
			} catch (err) {
				console.log(err);
			}
		};
		fetchAllData();
	}, [id]);

	const handleChange = (e) => {
		setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);

		try {
			await axios.post(`${process.env.REACT_APP_BACKEND_URL}/money/${id}`, data);
			navigate("/accountBalance");
		} catch (err) {
			console.log(err);
		} finally {
			setLoading(false);
		}
	};

	return (
		<CrudEditPage
			title={`Edit Balance: ${data.account}`}
			backLink="/accountBalance"
			backLabel="Back to Balances"
			breadcrumb={[
				{ label: "Money", to: "/lavella-dashboard" },
				{ label: "Account Balances", to: "/accountBalance" },
				{ label: data.account || `Balance #${id}` },
			]}
			onSubmit={handleSubmit}
			submitLabel="Update Balance"
			isLoading={loading}
			variant="v4"
			icon={<FiCreditCard />}
		>
			<FormGrid>
				<FormField label="Account" name="account" width="half">
					<select name="account" id="account" value={data.account} onChange={handleChange}>
						{accounts.map((account) => (
							<option key={account.account} value={account.account}>
								{account.account}
							</option>
						))}
					</select>
				</FormField>

				<FormField label="Value ($)" name="value" width="half">
					<input
						type="number"
						name="value"
						id="value"
						placeholder="0.00"
						value={data.value}
						onChange={handleChange}
						step="0.01"
					/>
				</FormField>
			</FormGrid>
		</CrudEditPage>
	);
};

export default UpdateAccountBalance;
